import { useEffect, useState } from 'react';

export const useEmbedding = (rootRef) => {
  const [dock, setDock] = useState({});
  const [editing, setEditing] = useState(false);
  const embedded = window.self !== window.top;
  useEffect(() => {
    const root = rootRef.current;
    if (!root) return;
    document.documentElement.classList.add('sim-document');
    if (embedded) document.documentElement.classList.add('sim-embedded');
    const sendHeight = () => window.parent.postMessage({ type: 'eb-quote-height', height: Math.ceil(root.getBoundingClientRect().height) }, '*');
    // L'intersection est calculée aussi à travers une iframe cross-origin.
    // Elle permet de garder le bouton dans la partie réellement visible, sans lire le parent.
    const probes = embedded ? [document.createElement('span'), document.createElement('span')] : [];
    probes.forEach((probe) => {
      probe.setAttribute('aria-hidden', 'true');
      Object.assign(probe.style, { position: 'absolute', left: '0', width: '1px', height: '1px', pointerEvents: 'none', opacity: '0' });
      root.appendChild(probe);
    });
    const intersection = embedded ? new IntersectionObserver(([entry]) => {
      const visibleBottom = entry.intersectionRect.bottom - entry.boundingClientRect.top;
      const bar = root.querySelector('.sim-mobile-bar');
      const height = bar?.getBoundingClientRect().height || 88;
      const top = Math.max(0, Math.min(root.offsetHeight - height, visibleBottom - height));
      const visibility = entry.isIntersecting ? 'visible' : 'hidden';
      setDock((previous) => previous.top === top && previous.visibility === visibility ? previous : { position: 'absolute', bottom: 'auto', top, visibility });
      probes.forEach((probe, index) => { probe.style.top = `${Math.max(0, Math.min(root.offsetHeight - 1, visibleBottom + (index ? 1 : -1)))}px`; });
    }, { threshold: [0, 1] }) : null;
    const refreshIntersection = () => { if (intersection) { intersection.unobserve(root); intersection.observe(root); } };
    // Le ratio du formulaire peut rester constant quand le parent défile.
    // Deux repères de part et d'autre du bas visible déclenchent alors un nouveau calcul.
    const probeObserver = embedded ? new IntersectionObserver(refreshIntersection, { threshold: [0, 1] }) : null;
    probes.forEach((probe) => probeObserver?.observe(probe));
    intersection?.observe(root);
    const resized = () => { sendHeight(); refreshIntersection(); };
    const resize = new ResizeObserver(resized);
    resize.observe(root); sendHeight();
    const focus = () => {
      const element = document.activeElement;
      setEditing(['TEXTAREA', 'SELECT'].includes(element?.tagName) || (element?.tagName === 'INPUT' && !['checkbox', 'radio', 'button', 'submit', 'range', 'color'].includes(element.type)));
    };
    const blur = () => requestAnimationFrame(focus);
    root.addEventListener('focusin', focus); root.addEventListener('focusout', blur);
    window.addEventListener('resize', resized);
    document.fonts?.ready.then(sendHeight);
    return () => {
      resize.disconnect(); intersection?.disconnect(); probeObserver?.disconnect(); probes.forEach((probe) => probe.remove()); window.removeEventListener('resize', resized);
      root.removeEventListener('focusin', focus); root.removeEventListener('focusout', blur);
      document.documentElement.classList.remove('sim-document', 'sim-embedded');
    };
  }, [rootRef]);
  return { dock, editing, embedded };
};